import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderTagsSection.title',
    defaultMessage: 'Order tags',
    description: 'Title of the process section',
  },
  emptyMessage: {
    id: 'pages.orderTagsSection.emptyMessage',
    defaultMessage: 'No order tags',
    description: 'Empty message of the order tags drawer',
  },
  actions: {
    edit: {
      label: {
        id: 'pages.orderTagsSection.actions.edit.label',
        defaultMessage: 'Edit',
        description: 'Label of the edit action in the process section',
      },
    },
  },
  orderTagsSettings: {
    title: {
      id: 'pages.orderTagsSection.orderTagsSettings.title',
      defaultMessage: 'Order tags',
      description: 'Title of the order tags drawer',
    },
  },
  feedback: {
    orderTagsUpdated: {
      id: 'pages.orderTagsSection.feedback.orderTagsUpdated',
      defaultMessage: 'Order tags updated',
      description: 'Succes message of the update order tags action',
    },
    orderTagsNotUpdated: {
      id: 'pages.orderTagsSection.feedback.orderTagsNotUpdated',
      defaultMessage: 'Order tags could not be updated',
      description: 'Error message of the order tags settings action',
    },
  },
};

export default defineMessages(translations);
